import angular from 'angular';
import ListingComponent from './components/listing';
import ViewComponent from './components/view';
import {UserConfig} from './components/user.config';
import uiRouter from 'angular-ui-router';
import Users from './services/user.service';
import UsersDataProvider from './services/user.dataprovider.service';

export default angular.module('users', [uiRouter])
  .component('usersListing', ListingComponent)
  .component('userView', ViewComponent)
  .service('Users', Users)
  .service('UsersDataProvider', UsersDataProvider)
  .config(UserConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/users/index.js
 **/